import { useEffect } from 'react';
import { userManager } from './userManager';

const SilentCallback = () => {
  useEffect(() => {
    const handleSilentCallback = async () => {
      try {
        await userManager.signinSilentCallback();
      } catch (err) {
        console.error('SilentCallback: Error processing silent callback:', err);
      }
    };

    handleSilentCallback();
  }, []);

  return null;
};

export default SilentCallback;
